import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const services = [
  {
    icon: 'ri-tools-line',
    title: 'Reparación rápida',
    desc: 'Brazos rotos, toldo que no recoge, lonas descosidas. Diagnóstico y reparación en 24/48h.',
    to: '/reparacion-toldos-malaga',
    img: '/images/017-service-repair-01.webp',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Instalación a medida',
    desc: 'Toldos nuevos para viviendas, terrazas y áticos. Adaptados a tu espacio y orientación solar.',
    to: '/instalacion-toldos-malaga',
    img: '/images/027-service-install-01.webp',
  },
  {
    icon: 'ri-cpu-line',
    title: 'Motorización',
    desc: 'Convertimos tu toldo manual en eléctrico. Instalación de motores, sensores de viento y sol.',
    to: '/motorizacion-toldos-malaga',
    img: '/images/023-service-motor-01.webp',
  },
  {
    icon: 'ri-drop-line',
    title: 'Mantenimiento',
    desc: 'Revisión anual, impermeabilización, limpieza de lona. Prepara tu toldo antes del verano.',
    to: '/mantenimiento-toldos-malaga',
    img: '/images/011-service-maintain-01.webp',
  },
];

export default function ServiciosUrgentes() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section ref={ref} className={`w-full bg-[#0F5066] py-16 md:py-20 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6 mb-12">
          <div className="flex flex-col gap-3">
            <span className="inline-flex px-3 py-1 rounded-full border border-white/20 text-white/80 text-xs font-medium font-label tracking-wide whitespace-nowrap w-fit">
              Nuestros servicios
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight">
              Soluciones rápidas<br />para tu toldo
            </h2>
          </div>
          <Link
            to="/presupuesto"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-foreground-900 text-sm font-semibold rounded-full hover:bg-accent-400 transition-all duration-300 whitespace-nowrap"
          >
            <span>Solicitar presupuesto</span>
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((service) => (
            <Link
              key={service.title}
              to={service.to}
              className="group block bg-secondary-100/95 rounded-2xl overflow-hidden hover:scale-[1.02] transition-all duration-300"
            >
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={service.img}
                  alt={service.title}
                  title={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col gap-2.5">
                <div className="flex items-center gap-2.5">
                  <div className="w-9 h-9 rounded-lg bg-primary-500/15 flex items-center justify-center flex-shrink-0">
                    <i className={`${service.icon} text-primary-500 text-lg`}></i>
                  </div>
                  <h3 className="text-base font-heading font-bold text-foreground-900 whitespace-nowrap">
                    {service.title}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {service.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}